import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { EndpointsService, NotificationService } from "../core/services/index";
import { Observable } from "rxjs/Rx";
import { CreatePublisherViewModel } from './publisher.model';

@Injectable()
export class PublishersService {
    private static notificationService;
    constructor(private http: Http, private endpointsService: EndpointsService, private notificationService: NotificationService) {
        PublishersService.notificationService = notificationService;
    }

    public getPublishers(): Observable<Response> {
        return this.http.get(this.endpointsService.GET_PUBLISHERS_DETAILS).catch(this.handleError);
    }

    public addPublisher(publisherViewModel: CreatePublisherViewModel) {
        return this.http.post(this.endpointsService.CREATE_PUBLISHER_URL, publisherViewModel)
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        if (error.status === 400)
            PublishersService.notificationService.showError(error.json().message)
        else
            PublishersService.notificationService.showError();
        return Observable.throw(error.json().error || 'Server Error');
    }
}


// WEBPACK FOOTER //
// ./src/app/publishers/publishers.service.ts